import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OauthModel } from '@shared/models/oauth/oauth.model';
import { environment } from 'src/environments/environment';
import { OauthResponseModel } from '@shared/models/oauth/oauth-response.model';
import { AuthModel } from '@shared/models/oauth/auth.model';
import { LoginResponseModel } from '@shared/models/auth/login-response.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private rootUrl = `${environment.apiUrl}/api`;
  private rootUrlAuth = `${environment.apiUrl}/api/auth/`;
  constructor(private http: HttpClient) {}

  getAccessToken() {
    return localStorage.getItem('AccessToken');
  }
  getToken(payload: OauthModel): Observable<OauthResponseModel> {
    return this.http.post<OauthResponseModel>(
      `${this.rootUrl}/oauth/token`,
      payload
    );
  }

  getAdminToken(payload: AuthModel): Observable<LoginResponseModel> {
    return this.http.post<LoginResponseModel>(
      `${this.rootUrl}/auth/login`,
      payload
    );
  }
  setToken(token: OauthResponseModel) {
    token.save();
  }
  Login1(data: any) {
    if (data)
      data['scopes'] = ['api'];
    const MethodName: string = '/auth/login';
    const url: string = this.rootUrl + MethodName;
    return this.http.post<any>(url, data);
  }
    Login(data: any) {
        data['scopes']=['api'];
        const formData = new FormData();
        if (data) {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    if (Array.isArray(data[key])) {
                        data[key].forEach((value: string, index: number) => {
                            formData.append(`${key}[${index}]`, value);
                        });
                    } else {
                        formData.append(key, data[key]);
                    }
                }
            }
        }
        const methodName: string = '/auth/login';
        const url: string = this.rootUrl + methodName;    
        return this.http.post<any>(url, formData);
    }
  ForgotPassword(data: any) {
    if (data)
      data['side'] = 'api';
    const MethodName: string = '/auth/password/reset';
    const url: string = this.rootUrl + MethodName;
    return this.http.post<any>(url, data);
  }

  ResetPassword(data: any) {
    const MethodName: string = '/auth/password/token';
    const url: string = this.rootUrl + MethodName;
    return this.http.post<any>(url, data);
  }
  franchiseLandlordPasswordReset(data: any) {
    const MethodName: string = 'advertiser-password-reset';
    const url: string = this.rootUrlAuth + MethodName;
    return this.http.post<any>(url, data);
}
}
